/* export function toPrice(price: number) {
 *   return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") + ' ₸';
 * } */
export function toPrice(price: number) {
  const integerPrice = Math.round(price);
  return integerPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") + " ₸";
}
